import { laptopMediumMax, laptopMediumMin, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import { Container as Button } from '@propertypal/web-ui/src/buttons/Button.style';
import {
  Container as PropertyDescription,
  DescriptionBox,
  OverlayBox,
} from '@propertypal/web-ui/src/property/PropertyDescription.style';
import { Container as PropertyPrice } from '@propertypal/web-ui/src/property/PropertyPrice.style';
import { CounterContainer } from '@propertypal/web-ui/src/property/PropertySlider.style';
import { Container as RelatedLinks } from '@propertypal/web-ui/src/property/RelatedLinks.style';
import {
  AccountLogo,
  AccountLogos,
  TextBoxBottom,
  TextBoxTop,
} from '@propertypal/web-ui/src/property-box/PropertyBox.style';
import { BackLink } from '@propertypal/web-ui/src/search/Beadcrumb.style';
import styled, { css } from 'styled-components';
import { Container as PropertyPdfBar, Content as PropertyPdfBarContent } from './PropertyPdfBar.style';

const MAX_WIDTH = 1260;

export const PNDetails = styled.div`
  padding-bottom: 40px;

  ${BackLink} {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: ${({ theme }) => theme.textDark};
    font-weight: 600;

    &:hover {
      color: ${({ theme }) => theme.primary};
    }
  }

  /* Slideshow */
  ${CounterContainer} {
    max-width: ${MAX_WIDTH + 60}px;
    margin: 0 auto;
  }

  /* Buttons */
  ${Button} {
    p {
      font-size: 17px;
    }
  }

  /* Related Links */
  ${RelatedLinks} {
    padding: 0px;
    text-align: left;
    line-height: 16px;
  }

  /* Property Price */
  ${PropertyPrice} {
    @media (${tabletMax}) {
      font-size: 36px !important;
    }
  }

  /* Downloads */
  ${PropertyPdfBar} {
    background: ${({ theme }) => theme.background};
    ${PropertyPdfBarContent} {
      padding: 20px 0;
    }
  }
`;

export const DetailsContent = styled.div`
  background: ${({ theme }) => theme.background};
  margin: -16px auto 20px;
  max-width: ${MAX_WIDTH}px;
  border-radius: 5px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 3;
  display: flex;

  @media (max-width: ${MAX_WIDTH + 30}px) {
    margin-left: 10px;
    margin-right: 10px;
  }

  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const PropertyTypesWrapper = styled.div<{ $isCrawfordsFarm: boolean }>`
  background: ${({ theme }) => theme.background};
  margin: ${({ $isCrawfordsFarm }) => ($isCrawfordsFarm ? 0 : -16)}px auto 20px;
  max-width: ${MAX_WIDTH + 50}px;
  position: relative;
  z-index: 0;

  @media (max-width: ${MAX_WIDTH + 30}px) {
    margin-left: 10px;
    margin-right: 10px;
  }

  ${TextBoxTop}, ${TextBoxBottom} {
    padding-right: 0;
  }

  ${AccountLogos} {
    img {
      max-width: 70px;
    }
  }

  ${AccountLogo} {
    width: 70px;
    height: 70px;
  }
`;

export const DetailsContentMain = styled.div`
  width: 100%;
  @media (${laptopMediumMin}) {
    max-width: 66.6%;
    flex-basis: 66.6%;
  }
`;

export const DetailsContentAdditional = styled.div`
  @media (${laptopMediumMin}) {
    flex-basis: 33.3%;
    max-width: 33.3%;
    border-left: 1px solid #dedede;
  }
  @media (${laptopMediumMax}) {
    border-top: 1px solid #dedede;
  }
`;

export const DetailsWrapper = styled.div`
  padding: 25px;
  height: 100%;

  @media (${laptopMediumMax}) {
    padding: 10px;
  }
`;

export const DesktopAgentBox = styled.div`
  display: block;
  @media (${laptopMediumMax}) {
    display: none;
  }
`;

export const MobileAgentBox = styled.div`
  display: none;
  @media (${laptopMediumMax}) {
    display: block;
  }
`;

export const StickyAdWrapper = styled.div`
  position: sticky;
  top: 75px;
  left: 0;
`;

export const DevDescriptionContainer = styled.div`
  width: 100%;
  max-width: 950px;
  padding: 0 16px;
  margin: 0 auto;

  ${PropertyDescription} {
    margin: 0;
  }

  ${DescriptionBox} {
    img {
      display: block;
      float: none;
      max-width: 950px;
      width: 100%;
      max-height: none;
      margin: 0 0 32px 0;
    }
  }

  ${OverlayBox} {
    display: none;
  }
`;

export const PremiumBanner = styled.div<{ $bg?: string }>`
  margin-bottom: 16px;

  ${({ $bg }) =>
    $bg
      ? css`
          background-color: ${$bg};
        `
      : ''}

  img {
    display: block;
  }
`;
